import React from "react";
import { Outlet, useLoaderData, Await } from "react-router-dom";
import AdminContentProvider from "@src/context/adminContext";
import { useAuthContext } from "@src/context";
import {
  stopUserActivityTracker,
  stopPageViewTracker,
} from "@src/utils/userActivityTracker"; // Import the function to stop tracking
import { Loader } from "../../components/atoms";
import { CardContainer } from "../../components/cards";

export const AdminContainer = () => {
  const { initialData } = useLoaderData();
  const { user, avatarInitials, setAvatarInitials } = useAuthContext();

  React.useEffect(() => {
    const first = user?.firstname?.[0] || "";
    const last = user?.lastname?.[0] || "";
    const expected = `${first}${last}`;
    if (avatarInitials !== expected) {
      setAvatarInitials(expected);
    }
  }, [user, avatarInitials, setAvatarInitials]);

  stopUserActivityTracker(); // Stop tracking when this component is rendered
  stopPageViewTracker(); // Stop page view tracking when this component is rendered

  const AdminSkeleton = () => (
    <>
      <Loader size="2xl" text="Howdy Signoler..." textColor="primary" />
    </>
  );

  return (
    <React.Suspense fallback={<AdminSkeleton />}>
      <Await resolve={initialData}>
        {(adminData) => (
          <AdminContentProvider adminData={adminData}>
            <Outlet />
          </AdminContentProvider>
        )}
      </Await>
    </React.Suspense>
  );
};
